/* istanbul ignore file */

import HideAt from './HideAt';

export default HideAt;
